module.exports = __webpack_public_path__ + "img/favicon.6de1ae80.png";